import { MiniPayTableProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/MiniPayTableProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { HorizontalLayout } from "@lib/titan2/dist/game/control/layout/HorizontalLayout";
import * as PIXI from "pixi.js";
import { PayTableCellLandscapeProperties } from "../landscape/PayTableLandscapeProperties";
/**
 * MiniPayTablePortraitProperties.ts
 */
export class MiniPayTablePortraitProperties extends MiniPayTableProperties {
    spacingFunction(index) {
        return [
            55,
            60,
            65,
            65,
            80,
            80,
            85,
            105,
            140,
            140
        ][index];
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.position.set(-89, 360);
        this.scale.set(1);
        this.cellProperties = [
            new MiniPayTableCellProperties12(),
            new MiniPayTableCellProperties10(),
            new MiniPayTableCellProperties9(),
            new MiniPayTableCellProperties8(),
            new MiniPayTableCellProperties7(),
            new MiniPayTableCellProperties6(),
            new MiniPayTableCellProperties5(),
            new MiniPayTableCellProperties4(),
            new MiniPayTableCellProperties3(),
            new MiniPayTableCellProperties2(),
            new MiniPayTableCellProperties1()
        ];
        this.portraitPrimary = true;
        this.panelProperties.layout = new HorizontalLayout(this.spacingFunction, ControlConstants.LEFT, true);
        this.panelProperties.position = new PIXI.Point(155, 0);
        this.backToGameButtonProperties.visible = false;
        this.animationProperties.position = new PIXI.Point(604.5, 53);
    }
}
/**
 * MiniPayTableCellProperties.ts
 */
export class MiniPayTableCellProperties extends PayTableCellLandscapeProperties {
    setDefaultValues() {
        this.orientation = "portrait";
        super.setDefaultValues();
        this.labelPos = new PIXI.Point(0, 0);
        this.labelPos = new PIXI.Point(0, 0);
        this.fieldPos = new PIXI.Point(0, 0);
        this.altFieldPos = new PIXI.Point(0, 0);
        this.labelSize = new PIXI.Point(0, 77);
        this.labelSize = new PIXI.Point(0, 77);
        this.fieldSize = new PIXI.Point(0, 77);
        this.altFieldSize = new PIXI.Point(0, 77);
        this.useShortLabel = false;
        this.backgroundProperties.position = new PIXI.Point(566, 60);
        this.effectsProperties.position = new PIXI.Point(566, 60);
        this.inactiveLabelProperties.position = this.labelPos.clone();
        this.inactiveLabelProperties.horizontalAlign = ControlConstants.CENTER;
        this.inactiveLabelProperties.verticalAlign = ControlConstants.CENTER;
        this.inactiveLabelProperties.size = this.labelSize.clone();
        this.activeLabelProperties.position = this.labelPos.clone();
        this.activeLabelProperties.horizontalAlign = ControlConstants.CENTER;
        this.activeLabelProperties.verticalAlign = ControlConstants.CENTER;
        this.activeLabelProperties.size = this.labelSize.clone();
        this.inactiveFieldProperties.visible = false;
        this.inactiveOrFieldProperties.visible = false;
        this.inactiveAltFieldProperties.visible = false;
        this.activeFieldProperties.visible = false;
        this.activeOrFieldProperties.visible = false;
        this.activeAltFieldProperties.visible = false;
        this.highlightFieldProperties.visible = false;
        this.highlightOrFieldProperties.visible = false;
        this.highlightAltFieldProperties.visible = false;
    }
}
/**
 * MiniPayTableCellProperties12.ts
 */
export class MiniPayTableCellProperties12 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "11";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties10.ts
 */
export class MiniPayTableCellProperties10 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "10";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties9.ts
 */
export class MiniPayTableCellProperties9 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "9";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties8.ts
 */
export class MiniPayTableCellProperties8 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "8";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties7.ts
 */
export class MiniPayTableCellProperties7 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "7";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties6.ts
 */
export class MiniPayTableCellProperties6 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "6";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties5.ts
 */
export class MiniPayTableCellProperties5 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "5";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties4
 */
export class MiniPayTableCellProperties4 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "4";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties3.ts
 */
export class MiniPayTableCellProperties3 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "3";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties2.ts
 */
export class MiniPayTableCellProperties2 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "2";
        this.reInitialiseFieldProperties();
    }
}
/**
 * MiniPayTableCellProperties1.ts
 */
export class MiniPayTableCellProperties1 extends MiniPayTableCellProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.id = "1";
        this.reInitialiseFieldProperties();
    }
}
